import { ReactNode } from 'react';
import styled from 'styled-components';

import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';

const AverageScore = styled.div`
  display: inline-block;
  border-radius: var(--double-unit);
  font: var(--t-bold) var(--t-16);
  height: var(--quadruple-unit);
  min-width: var(--quadruple-unit);
  line-height: var(--quadruple-unit);
  text-align: center;
  background: var(--accent-color, var(--c-neutral-400));
`;

type Props = {
  title: NonNullable<ReactNode>;
  children: ReactNode;
  className?: string;
};

export const UsSportsScore: React.FC<Props> = ({
  title,
  className,
  children,
}) => {
  return (
    <AverageScore className={className}>
      <Tooltip title={title}>{children}</Tooltip>
    </AverageScore>
  );
};
